import { next, schedule } from '@ember/runloop';

import type { ReactIntegrations, Service } from 'webapp-types';
import { AppEvent } from 'webapp/enums/events';

export interface ReactMountHost {
	reactService: Service.React;
	eventManagerService: Service.EventManager;
	reactElement: ReactIntegrations.Root;
}

// Creates a React root in `node` and re-renders it via `render` whenever the access token or the
// theme changes. The first render is deferred (afterRender → next) so the host element is fully in
// the DOM first. Shared by the Genie full-screen and settings mounts; pair with `unmountReactRoot`.
export function mountReactRoot(host: ReactMountHost, node: HTMLElement, render: () => void): void {
	host.reactElement = host.reactService.create(node as HTMLDivElement);

	schedule('afterRender', () => {
		next(render);
	});

	host.eventManagerService.on(AppEvent.ACCESS_TOKEN_REFRESHED, host, render);
	host.eventManagerService.on(AppEvent.THEME_CHANGED, host, render);
}

// Reverses `mountReactRoot`: unmounts the React root and removes its event listeners.
export function unmountReactRoot(host: ReactMountHost): void {
	host.reactService.unmount(host.reactElement);
	// a first render still pending in `next()` bails out on a null root
	host.reactElement = null;
	host.eventManagerService.off(AppEvent.ACCESS_TOKEN_REFRESHED, host);
	host.eventManagerService.off(AppEvent.THEME_CHANGED, host);
}
